module.exports = __webpack_public_path__ + "static/media/lock.f8f29a3b.svg";